import { render, staticRenderFns } from "./PedidosVsDespacho.vue?vue&type=template&id=4cfffbba&scoped=true&"
import script from "./PedidosVsDespacho.vue?vue&type=script&lang=js&"
export * from "./PedidosVsDespacho.vue?vue&type=script&lang=js&"
import style0 from "./PedidosVsDespacho.vue?vue&type=style&index=0&id=4cfffbba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfffbba",
  null
  
)

export default component.exports